import FiltersSortHeaderWrapper from "components/Filters/SortHeader/Wrapper";
import FiltersSortHeaderSortableColumn from "components/Filters/SortHeader/SortableColumn";
import useFiltersSortHeader from "components/Filters/SortHeader/useFiltersSortHeader";

import { COLUMN_GAP, COLUMN_ORDER, SortableColumns } from "../constants";

const WorkerPoolsFiltersLayoutHeader = () => {
  const { querySortOption, querySortDirection, onItemClick } = useFiltersSortHeader();

  return (
    <FiltersSortHeaderWrapper ariaRole="row" columnOrder={COLUMN_ORDER} columnGap={COLUMN_GAP}>
      <FiltersSortHeaderSortableColumn
        option={{
          label: SortableColumns.NAME,
          value: SortableColumns.NAME,
        }}
        wrapperAriaRole="columnheader"
        querySortOption={querySortOption}
        querySortDirection={querySortDirection}
        onClick={onItemClick}
      />
      <FiltersSortHeaderSortableColumn
        wrapperAriaRole="columnheader"
        option={{
          label: SortableColumns.SPACE,
          value: SortableColumns.SPACE,
        }}
        querySortOption={querySortOption}
        querySortDirection={querySortDirection}
        onClick={onItemClick}
      />
      <FiltersSortHeaderSortableColumn
        wrapperAriaRole="columnheader"
        option={{
          label: "Workers",
          value: SortableColumns.WORKERS,
        }}
        querySortOption={querySortOption}
        querySortDirection={querySortDirection}
        onClick={onItemClick}
      />
      <FiltersSortHeaderSortableColumn
        wrapperAriaRole="columnheader"
        option={{
          label: "Busy",
          value: SortableColumns.BUSY,
        }}
        querySortOption={querySortOption}
        querySortDirection={querySortDirection}
        onClick={onItemClick}
      />
      <FiltersSortHeaderSortableColumn
        wrapperAriaRole="columnheader"
        option={{
          label: "Queue",
          value: SortableColumns.QUEUE,
        }}
        querySortOption={querySortOption}
        querySortDirection={querySortDirection}
        onClick={onItemClick}
      />
    </FiltersSortHeaderWrapper>
  );
};

export default WorkerPoolsFiltersLayoutHeader;
